module.exports = __webpack_public_path__ + "img/y_p2_ganzhi.5c096b17.svg";